// Shared Activities Puck blocks - used by both MembersApp and CoachesApp

// Types
export * from "./ActivitiesTypes";

// Utils
export * from "./utils";

// Context
export {
  ActivitiesDataProvider,
  useActivitiesData,
  ActivityItemProvider,
  useActivityItem,
  type ActivitiesContextValue,
  type ActivityItemContextValue,
} from "./ActivitiesDataContext";

// Puck Config and Page Data
export { activitiesPuckConfig, getActivitiesPuckConfig } from "./ActivitiesPuckConfig";
export {
  defaultActivitiesPageData,
  getCurrentActivitiesPageSlug,
  getStoredPuckDataForPage,
  savePuckDataForPage,
  storageKeyForSlug,
} from "./ActivitiesPuckPageData";

// Puck Blocks
export { default as ActivitiesAsyncGate } from "./ActivitiesAsyncGateBlock";
export { default as ActivitiesList } from "./ActivitiesListBlock";
export { default as ActivitiesWeeklySummary } from "./ActivitiesWeeklySummaryBlock";
export { default as ActivityHeader } from "./ActivityHeaderBlock";
export { default as ActivityRow } from "./ActivityRowBlock";
export { default as ActivitySparkline } from "./ActivitySparklineBlock";
export { default as ActivityTile } from "./ActivityTileBlock";
export { default as HrmLoanAlert } from "./HrmLoanAlertBlock";
export { default as WeeklyDecisionTile } from "./WeeklyDecisionTileBlock";
export { default as WeeklyLoadsBar } from "./WeeklyLoadsBarBlock";
export { default as WeeklyLoadTile } from "./WeeklyLoadTileBlock";
export { default as WeeklyMonotonyTile } from "./WeeklyMonotonyTileBlock";
export { default as WeeklySessionsTile } from "./WeeklySessionsTileBlock";
export { default as WeeklyStatTile } from "./WeeklyStatTileBlock";